module.exports = __webpack_public_path__ + "static/media/S4N7-3.fc019043.svg";